import { Shimmer } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

/**
 * UI for rendering whether Customer Action on CVE is required on the CVE details page's title card.
 */
export const CustomerActionRequiredTitle = ({
  isCustomerActionRequired,
  loading,
}: {
  isCustomerActionRequired?: boolean;
  loading?: boolean;
}) => {
  const [t] = useTranslation(['vulnerability']);
  if (isCustomerActionRequired === undefined) return null;

  const customerActionRequiredText = t(
    'customerAction.noActionRequired',
    'The vulnerability documented by this CVE requires no customer action to resolve'
  );

  return (
    <Shimmer
      styles={{ root: { minWidth: '8em', padding: '.5rem 0' } }}
      isDataLoaded={!loading}
    >
      <b>{customerActionRequiredText}</b>
    </Shimmer>
  );
};
